import { useContext } from 'react';

import { SettingSaveContext } from '../../contexts/SettingSaveContext';

export const useSettingSave = () => {
  const context = useContext(SettingSaveContext);
  if (context === undefined) {
    throw new Error('useSetting must be used within an SettingProvider');
  }
  return context;
};
